import { IconButton } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import { SnackbarProvider } from "notistack";
import React from "react";
import ConfigProvider from "src/context/config/configContext";
import UserProvider from "src/context/config/userContext";
import AnalysisOverviewProvider from "src/context/monitoring/analysisOverviewContext";
import TransactionMonitoringProvider from "src/context/monitoring/transactionMonitoringContext";
import UserAnalysisProvider from "src/context/monitoring/userAnalysisContext";
import UserMonitoringProvider from "src/context/monitoring/userMonitoringContext";
import PoolsProvider from "src/context/poolsContext";
import TokenAnalysisProvider from "src/context/tokenAnalysisContext";
import ProviderProvider from "src/ether-utils/context/providerContext";
import { Web3ConnectProvider } from "../wallet-connection/context/we3-connect-context";
import WrapperApp from "./WrapperApp";

const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};

const AnalysisContextApp = () => (
  <TokenAnalysisProvider>
    <TransactionMonitoringProvider>
      <UserMonitoringProvider>
        <UserAnalysisProvider>
          <AnalysisOverviewProvider>
            <WrapperApp />
          </AnalysisOverviewProvider>
        </UserAnalysisProvider>
      </UserMonitoringProvider>
    </TransactionMonitoringProvider>
  </TokenAnalysisProvider>
);

const PoolsContextApp = () => (
  <PoolsProvider>
    <AnalysisContextApp />
  </PoolsProvider>
);

export default function ContextApp() {
  return (
    <Web3ConnectProvider defaultChainId={56} allowedChainIds={[56, 250, 1, 97]}>
      <ProviderProvider>
        <ConfigProvider>
          <UserProvider>
            <SnackbarProvider
              maxSnack={3}
              ref={notistackRef}
              preventDuplicate
              action={(key) => (
                <IconButton size="small" color="inherit" onClick={onClickDismiss(key)}>
                  <ClearIcon style={{ cursor: "pointer" }} fontSize="small" />
                </IconButton>
              )}
            >
              <PoolsContextApp />
            </SnackbarProvider>
          </UserProvider>
        </ConfigProvider>
      </ProviderProvider>
    </Web3ConnectProvider>
  );
}
